import React, { useState, useEffect } from 'react';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const WinBar = () => {
    const [loader, setLoader] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [winbarData, setWinbarData] = useState({
        _id: '',
        text: '',
        status: true
    });
    const [formData, setFormData] = useState({
        text: '',
        status: true
    });

    const fetchData = async () => {
        try {
            setLoader(true);
            const resp = await Calling.getWinbar();
            console.log(resp);

            if (resp.status && resp.data) {
                setWinbarData(resp.data);
                setFormData({
                    text: resp.data.text || '',
                    status: resp.data.status === true
                });
            } else {
                toast.error(resp.message || 'Failed to fetch data');
            }
        } catch (error) {
            console.log(error);
            toast.error('An error occurred while fetching data');
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleStatusChange = (e) => {
        setFormData(prev => ({
            ...prev,
            status: e.target.value === 'true'
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.text.trim()) {
            toast.error('Text is required');
            return;
        }

        try {
            setLoader(true);

            const resp = await Calling.updateWinbar({
                'text': formData.text,
                'status': formData.status
            });

            if (resp.status) {
                toast.success('Winbar updated successfully');
                setShowEditForm(false);
                fetchData();
            } else {
                toast.error(resp.message || 'Update failed');
            }
        } catch (error) {
            console.error(error);
            toast.error('An error occurred');
        } finally {
            setLoader(false);
        }
    };

    const handleEdit = () => {
        setShowEditForm(true);
    };

    const handleCancel = () => {
        setShowEditForm(false);
        // Reset form data to current winbar data
        setFormData({
            text: winbarData.text || '',
            status: winbarData.status === true
        });
    };

    if (loader) return (<Loader loader={loader} />);

    return (
        <div className="px-3 sm:px-4 lg:ml-[4.4rem] text-main-font bg-main-bg mt-16 md:mt-20">
            <div className="container mx-auto">
                {/* Form Section - Only visible when editing */}
                {showEditForm && (
                    <div className="bg-main-white p-5 rounded-lg shadow-md mb-8 border-l-4 border-main-yellow">
                        <h2 className="text-xl font-semibold mb-4 text-main-blue">
                            Update Winbar
                        </h2>

                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div>
                                <label className="block text-sm font-medium mb-1 text-main-font">
                                    Text
                                </label>
                                <textarea
                                    name="text"
                                    value={formData.text}
                                    onChange={handleInputChange}
                                    className="w-full p-3 border border-main-border rounded-lg focus:outline-none focus:ring-2 focus:ring-main-blue bg-main-bg min-h-[100px]"
                                    placeholder="Enter text"
                                />
                                <p className="text-xs text-main-subfont mt-1">
                                    Use emojis and text to create your winner display bar
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-1 text-main-font">
                                    Status
                                </label>
                                <select
                                    name="status"
                                    value={formData.status.toString()}
                                    onChange={handleStatusChange}
                                    className="w-full p-3 border border-main-border rounded-lg focus:outline-none focus:ring-2 focus:ring-main-blue bg-main-bg"
                                >
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                            </div>

                            <div className="flex gap-4 pt-2">
                                <button
                                    type="submit"
                                    className="px-6 py-3 bg-main-blue text-white rounded-lg hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-main-blue focus:ring-opacity-50 transition-colors shadow-md"
                                >
                                    Update Winbar
                                </button>
                                <button
                                    type="button"
                                    onClick={handleCancel}
                                    className="px-6 py-3 bg-main-border text-main-font rounded-lg hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-main-border focus:ring-opacity-50 transition-colors"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                {/* Current Winbar Preview */}
                <div className="bg-main-white p-5 rounded-lg shadow-md">
                    <div className="flex justify-between items-center mb-4">
                        <h1 className="text-2xl font-bold text-main-blue">Current Winbar</h1>
                        {!showEditForm && (
                            <button
                                onClick={handleEdit}
                                className="px-4 py-2 bg-main-th text-main-blue rounded-lg hover:bg-main-blue hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-main-blue"
                            >
                                Edit
                            </button>
                        )}
                    </div>

                    <div className="bg-main-blue text-white p-4 rounded-lg overflow-hidden">
                        <div className="marquee-container">
                            <div className={winbarData.status ? "marquee-content" : "marquee-content-paused"}>
                                {winbarData.text || "No content available"}
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 flex items-center">
                        <span className="mr-2">Status:</span>
                        <span className={`px-2 py-1 rounded-full text-xs ${winbarData.status
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                            }`}>
                            {winbarData.status ? 'Active' : 'Inactive'}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WinBar;